//业务相关的公共方法将在这里
import store from '@/store/index.js';
import utils from "@/common/utils";
import * as apiworkClue from '@/common/apiworkClue';

export default {
  //获取到用户的token值
  usertoken() {
    store.commit('getToken')
    return store.state.user.token
  },
  //获取到用户的头像路径url
  getEqUserImg() {
    store.commit('getUserimg')
    let usrimgurl = utils.getBaseUrl() + '/SysFile/equser_img.png'
    try {

      if (store.state.user.userimg) {
        usrimgurl = utils.getBaseUrl() + JSON.parse(store.state.user.userimg)[0].url
      }
    } catch (e) {
      // 静默处理错误
    }
    return usrimgurl
  },
  //获取到用户名
  getUsername() {
    store.commit('getUsername')
    return store.state.user.username
  },
  // 当前日期时间 YYYY-MM-DD HH:mm:ss
  getCurrentDateTime() {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  },
  // 重置制单日期 newtime 为当前时间（勾选「添加时强制默认值」时不覆盖）
  resetNewtime(formData, formLabel) {
    if (!formData || !Object.prototype.hasOwnProperty.call(formData, 'newtime')) {
      return formData
    }
    if (Array.isArray(formLabel)) {
      const field = formLabel.find(i => i && i.model === 'newtime')
      if (field && this.isDefaultEmpty(field)) {
        return formData
      }
    }
    formData.newtime = this.getCurrentDateTime()
    return formData
  },
  //写入组件默认值到表单数据集合
  setFormDefaultValue(formData, item) {
    let psformData = JSON.parse(JSON.stringify(formData))
    // 将组件默认值写入进组件数据集合
    if (item && item.model) {
      if (item.type === 'table' || item.type === 'apicom') {
        // 如果字段类型是表格，初始化为空数组
        if (psformData[item.model] === undefined || psformData[item.model] === null || psformData[item.model] === '') {
          psformData[item.model] = []
        }
        // 如果设置了默认值，使用默认值（但默认值应该是数组格式）
        if (item.defaultlable !== undefined && item.defaultlable !== null && item.defaultlable !== '') {
          // 如果默认值是字符串，尝试解析为数组
          if (typeof item.defaultlable === 'string') {
            try {
              psformData[item.model] = JSON.parse(item.defaultlable)
            } catch (e) {
              psformData[item.model] = []
            }
          } else if (Array.isArray(item.defaultlable)) {
            psformData[item.model] = item.defaultlable
          }
        }
      } else if (this.supportsDefaultEmpty(item) && this.isDefaultEmpty(item)) {
        // 勾选「添加时强制默认值」优先于制单人/当天等自动填充
        psformData[item.model] = this.getForcedDefaultValue(item)
      }
      // 如果model是newaccount（系统制单人），则赋值当前登录账户名
      else if (item.model === 'newaccount') {
        psformData[item.model] = this.getUsername()
      }
      // 如果model是lczt（流程状态），则赋值"待审"
      else if (item.model === 'lczt') {
        psformData[item.model] = '待审'
      }
      // 如果字段类型是equser，则赋值当前登录用户名
      else if (item.type === 'equser') {
        // 如果是多选字段，设置为数组格式
        if (item.ismultiple) {
          psformData[item.model] = [this.getUsername()]
        } else {
          psformData[item.model] = this.getUsername()
        }
      } else if (item.type === 'eqrole') {
        // 如果字段类型是eqrole，处理多选情况
        if (item.ismultiple) {
          psformData[item.model] = []
        } else {
          psformData[item.model] = ''
        }
      } else if (item.type === 'date' || item.type === 'datetime') {
        // 有默认数据用默认，否则当天/当前时间
        if (item.defaultlable !== undefined && item.defaultlable !== null && item.defaultlable !== '') {
          psformData[item.model] = item.defaultlable
        } else if (item.type === 'datetime') {
          psformData[item.model] = this.getCurrentDateTime()
        } else {
          const today = new Date()
          const year = today.getFullYear()
          const month = String(today.getMonth() + 1).padStart(2, '0')
          const day = String(today.getDate()).padStart(2, '0')
          psformData[item.model] = `${year}-${month}-${day}`
        }
      } else if (item.defaultlable !== undefined) {
        // 其他类型使用默认值
        psformData[item.model] = item.defaultlable
      }
    }
    return psformData
  },

  /** 解析字段 otherConfig（兼容字符串 / False） */
  parseFieldOtherConfig(otherConfig) {
    if (!otherConfig || otherConfig === 'False') return {}
    if (typeof otherConfig === 'object' && !Array.isArray(otherConfig)) return otherConfig
    if (typeof otherConfig === 'string') {
      try {
        const parsed = JSON.parse(otherConfig)
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
      } catch (e) {
        return {}
      }
    }
    return {}
  },

  /** 表格/附件等类型不展示「添加时强制默认值」 */
  supportsDefaultEmpty(item) {
    if (!item || !item.type) return false
    return !['image', 'upimg', 'upfile', 'table', 'apicom', 'separator', 'qrcode'].includes(item.type)
  },

  /** otherConfig.defaultEmpty 是否勾选 */
  isDefaultEmpty(item) {
    if (!item) return false
    const flag = this.parseFieldOtherConfig(item.otherConfig).defaultEmpty
    return flag === true || flag === 'true' || flag === 1
  },

  /** 强制默认值：有默认数据用默认数据，否则空 */
  getForcedDefaultValue(item) {
    if (item && item.defaultlable !== undefined && item.defaultlable !== null && item.defaultlable !== '') {
      return item.defaultlable
    }
    if (item && (item.type === 'checkbox' || (item.ismultiple && item.type !== 'apiworkid'))) {
      return []
    }
    return ''
  },

  /** 仅对勾选 defaultEmpty 的字段写强制默认值 */
  applyDefaultEmptyFields(target, fieldList) {
    if (!target || typeof target !== 'object' || !Array.isArray(fieldList)) return target
    fieldList.forEach((item) => {
      if (!item || !item.model) return
      if (!this.supportsDefaultEmpty(item) || !this.isDefaultEmpty(item)) return
      target[item.model] = this.getForcedDefaultValue(item)
    })
    return target
  },

  /** 添加/复制：按表单配置强制默认值（含表格子列） */
  applyDefaultEmpty(formData, formLabel) {
    if (!formData || !Array.isArray(formLabel)) return formData
    this.applyDefaultEmptyFields(formData, formLabel)
    formLabel.forEach((item) => {
      if (!item || (item.type !== 'table' && item.type !== 'apicom')) return
      const rows = formData[item.model]
      if (!Array.isArray(rows) || !Array.isArray(item.tableformlist)) return
      rows.forEach((row) => {
        if (row && typeof row === 'object') {
          this.applyDefaultEmptyFields(row, item.tableformlist)
        }
      })
    })
    return formData
  },
  
  //处理动态地址中的变量替换
  processDynamicUrl(template, formData, scanContent = null) {
    if (!template || typeof template !== 'string') {
      return template
    }
    
    // 替换 {字段名} 格式的变量
    return template.replace(/\{([^}]+)\}/g, (match, fieldName) => {
      // 特殊字段处理
      if (fieldName === 'currentUser') {
        return this.getUsername()
      }
      
      // 扫描内容处理
      if (fieldName === 'scanField' && scanContent !== null) {
        return encodeURIComponent(String(scanContent))
      }
      
      // 从表单数据中获取字段值
      const value = formData[fieldName]
      return value !== undefined && value !== null ? encodeURIComponent(String(value)) : ''
    })
  },
  
  //导出excel时，获取列表列名的列名集，formLabel为组件元素集，prop:是否显示组件标识标题，titlename:第一组标题的名称；titlearr：为第一组附加标题数据
  // options.skipMainFieldMerge: 导入模板模式，不合并主表列，每行重复主表字段便于编辑
  getExHeader(tabledata, formLabel, prop, titlename, titlearr = [], options = {}) {
    const skipMainFieldMerge = options.skipMainFieldMerge === true
    //将要返回的导出数据信息
    let exhead = {multiHeader: [], labelhead: [], prophead: [], exmerges: [], exdata: []}//multiHeader:第一组表头信息，labelhead：第二组标题信息，prophead：组件标识标题，exmerges：合并行列信息
    //titlehead为multiHeader中的抬头
    let titlehead = []
    //labelhead中的主组件表头，和表格子数据列表头
    let formhead = []
    let tablehead = []
    //所在y轴的坐标值
    let merge_y_num = 0;
    // 过滤掉 separator 和 tabs 类型的字段（包括主表和子表）
    const filteredFormLabel = (formLabel || []).map(item => {
      if (item.type === 'table' || item.type === 'apicom') {
        // 如果是表格组件，也需要过滤子表中的 separator 字段
        if (item.tableformlist && Array.isArray(item.tableformlist)) {
          return {
            ...item,
            tableformlist: item.tableformlist.filter(subItem => subItem.type !== 'separator')
          }
        }
      }
      return item
    }).filter(item => item.type !== 'separator' && item.type !== 'tabs')
    //筛选出table组件集
    let tablelabel = filteredFormLabel.filter(item => item.type === 'table' || item.type === 'apicom')

    //插入第一组的抬头标题，判断标题是否存在
    if (titlename) {
      exhead.multiHeader.push(titlehead)
    }
    //插入第一组的附加行信息,判断附加行组是否存在
    exhead.multiHeader.push(...titlearr)
    if (exhead.multiHeader) {
      merge_y_num += exhead.multiHeader.length
    }
    let labelhead_x_num = 0;//列头数据表头的X轴下标
    let labelhead_y_num1 = merge_y_num + 1;//列头数据主组件的Y轴坐标
    let labelhead_y_num2 = merge_y_num + 2;//列头数据表格组件所在的Y轴坐标
    /********1.格式化数据，excel数据组拼接**********/
    filteredFormLabel.forEach(item => {
      if (item.type === 'table' || item.type === 'apicom') {//如果组件类型是table表格组件时，就将子表单组件列循环拼接

        if (item.tableformlist.length > 0) {//判断如果table表格组件设置了子组件信息时进入拼接
          item.tableformlist.forEach(subitem => {
            labelhead_x_num += 1;
            //插入第一行抬头数据
            titlehead.push(titlename)
            //拼接表单列头数据
            formhead.push(item.label)
            tablehead.push(subitem.label)
            if (prop) {
              //插入表单组件标识列头
              exhead.prophead.push(subitem.model)
            }
          })
          //计算出表格组件第一个表头的X轴开始坐标
          let uplabelhead_x_num = labelhead_x_num - item.tableformlist.length + 1;
          //计算拼接表格组件的主组件标题X轴的合并值
          let mergesitem = utils.numToString(uplabelhead_x_num) + labelhead_y_num1.toString() + ":" + utils.numToString(labelhead_x_num) + labelhead_y_num1.toString()
          exhead.exmerges.push(mergesitem)
        } else {//如果table表格只添加了表格组件，但是没有设置表格子组件时，插入空的表格，避免样式错乱
          labelhead_x_num += 1;
          //插入第一行抬头数据
          titlehead.push(titlename)
          //拼接表单列头数据
          formhead.push(item.label)
          tablehead.push("")
          if (prop) {
            //插入表单组件标识列头
            exhead.prophead.push("")
          }
        }
      } else {
        labelhead_x_num += 1;
        //计算出存在表格组件的情况下，主组件Y轴的合并值；
        if (tablelabel) {//如果有子表格的时候，就进行表格头部标题的合并列计算
          let mergesitem = utils.numToString(labelhead_x_num) + labelhead_y_num1.toString() + ":" + utils.numToString(labelhead_x_num) + labelhead_y_num2.toString()
          exhead.exmerges.push(mergesitem)
        }
        //插入第一行抬头数据
        titlehead.push(titlename)
        //拼接表单列头数据
        formhead.push(item.label)
        tablehead.push('')
        if (prop) {
          //插入表单组件标识列头
          exhead.prophead.push(item.model)
        }

      }
    })
    //断标题是否存在，如果存在就重新更改赋值标题titlehead
    if (titlename) {
      exhead.multiHeader[0] = titlehead
    }
    //插入第二组标题，数据列头
    exhead.labelhead.push(formhead)
    //插入第二组标题，判断是否存在表格子组件，如果存在就插入子表格列头
    if (tablelabel) {
      exhead.labelhead.push(tablehead)
    }
    //组件表头列名拼接完成后，让excel全部数据的Y轴坐标累加labelhead数据表题的集合行数
    merge_y_num += exhead.labelhead.length;
    //如果prophead 组件标识标题不是空的，prophead的标题为固定的1行,就让excel数据的Y轴坐标累计上1;
    if (exhead.prophead && exhead.prophead.length > 0) {
      merge_y_num += 1;
    }

    /********************2.计算第一组表头合并行信息**************/
    //计算第一行multiHeader头信息的合并数据
    if (exhead.multiHeader && exhead.multiHeader.length > 0) {
      for (let i = 1; i <= exhead.multiHeader.length; i++) {
        let mergesitem = "A" + i + ":" + utils.numToString(exhead.multiHeader[i - 1].length) + i;
        exhead.exmerges.push(mergesitem)
      }
    }

    /********************3.格式化tabledata的数据信息**************/
    tabledata.forEach(dataitem => {//3.1循环列表数据的每一行
      let table_length = 1;//当前数据表格占行数量
      let table_x_num = 0;//当前数据的x轴占列数量，用于计算合并
      let table_y_num = merge_y_num + 1;//当前行数据的Y轴开始值

      //循环组件内的table数据表格组件，取得最大的数据行数，方便拼接合并
      tablelabel.forEach(tableitem => {
        try {
          let tabdataval = JSON.parse(dataitem[tableitem.model])//获取到表格数据集
          if (tabdataval.length > table_length)//如果当前表格数据的条数，大于一直的行数，就为已知行数赋值
          {
            table_length = tabdataval.length
          }
        } catch (e) {
          e
        }
      })

      //让excel全部数据的Y轴坐标累加数据的行数
      merge_y_num += table_length;
      //循环当前行数据子表格table组件的最大行数，获取每一行的数据
      for (var c = 0; c < table_length; c++) {
        let exdataitem = [];//当前数据表格的单行数据集
        table_x_num = 0;//循环当前行数据时，每次都将行的X坐标初始化为0，用于计算合并列
        filteredFormLabel.forEach(labelitem => {
          if (labelitem.type === 'table' || labelitem.type === 'apicom') {
            let tabdataval
            try {
              tabdataval = JSON.parse(dataitem[labelitem.model])//获取到当前table的数据
            } catch (e) {
              tabdataval = []
            }
            if (labelitem.tableformlist.length > 0) {//如果table设置表格子组件时，插入对应的数据
              labelitem.tableformlist.forEach(subitem => {//类型是table数据表格时就循环表格子组件
                table_x_num += 1;//每次循环组件列名，就将x轴的占比数累加
                try {
                  exdataitem.push(this.ExFormatData(tabdataval[c][subitem.model], subitem))
                } catch (e) {
                  exdataitem.push("")
                }
              })
            } else {//如果table表格只添加了表格组件，但是没有设置表格子组件时，插入空的表格，列头对应，避免样式错乱
              table_x_num += 1;//每次循环组件列名，就将x轴的占比数累加
              exdataitem.push("")
            }
          } else {
            table_x_num += 1;//每次循环组件列名，就将x轴的占比数累加
            exdataitem.push(this.ExFormatData(dataitem[labelitem.model], labelitem))
            if (!skipMainFieldMerge && c == table_length - 1 && table_length > 1) {//当数据循环到最后一行的时候，开始计算合并列数据
              let mergesitem = utils.numToString(table_x_num) + table_y_num.toString() + ":" + utils.numToString(table_x_num) + merge_y_num.toString()
              exhead.exmerges.push(mergesitem)
            }
          }
        })
        exhead.exdata.push(exdataitem)
      }


    })


    return exhead
  },

  //上传excel时用到的组件数值格式化方法
  ExFormatData(datavar, item) {
    if (item.type === 'num') {
      return utils.changeflaot(datavar, item.floatnum)
    }
    if (datavar) {
      if (item.type === 'datetime') {//将带有年月日时分秒的时间类型值转换
        datavar = utils.filterTime(datavar)
      } else if (item.type === 'date') {//将带有年月日的事件类型值转换
        datavar = utils.filterTime(datavar, 'date')
      } else if (item.type === 'table' || item.type === 'apicom') {
        datavar = '点击查看明细'
      } else if (item.type === 'upimg' || item.type === 'image') {
        // 处理图片字段：将 "文件名 (路径)" 格式转换为图片数组
        if (typeof datavar === 'string' && datavar.trim()) {
          try {
            // 先尝试解析为JSON（如果已经是JSON格式）
            const parsed = JSON.parse(datavar);
            if (Array.isArray(parsed)) {
              return parsed;
            }
          } catch (e) {
            // 不是JSON格式，继续处理文本格式
          }
          
          // 处理 "文件名 (路径)" 格式，支持多个图片用分号分隔
          const imageArray = [];
          const imageStrings = datavar.split(';').map(s => s.trim()).filter(s => s);
          
          imageStrings.forEach(imageStr => {
            // 匹配格式：文件名 (路径) 或 文件名(路径)
            const match = imageStr.match(/^(.+?)\s*\((.+?)\)$/);
            if (match) {
              const name = match[1].trim();
              const url = match[2].trim();
              if (name && url) {
                imageArray.push({
                  upname: name,
                  name: name,
                  url: url
                });
              }
            } else {
              // 如果没有括号，可能是纯URL或纯文件名
              // 尝试判断是URL还是文件名
              if (imageStr.startsWith('/') || imageStr.startsWith('http') || imageStr.startsWith('E5File/')) {
                // 看起来是URL
                const fileName = imageStr.split('/').pop() || 'image';
                imageArray.push({
                  upname: fileName,
                  name: fileName,
                  url: imageStr
                });
              } else {
                // 可能是文件名，尝试构建URL（假设在E5File目录下）
                imageArray.push({
                  upname: imageStr,
                  name: imageStr,
                  url: `/E5File/${imageStr}`
                });
              }
            }
          });
          
          // 如果解析到了图片数据，返回数组；否则返回空数组
          return imageArray.length > 0 ? imageArray : [];
        } else if (Array.isArray(datavar)) {
          // 如果已经是数组格式，直接返回
          return datavar;
        } else {
          // 其他情况返回空数组
          return [];
        }
      }
    }
    return datavar
  },
  //表单显示通用性格式化方法
  FormatData(datavar, item) {//datavar:数据值；item:列名信息
    if (datavar) {
      if (item.type === 'num') {//将数字类型的值转换
        datavar = utils.changeflaot(datavar, item.floatnum)
      } else if (item.type === 'datetime') {//将带有年月日时分秒的时间类型值转换
        datavar = utils.filterTime(datavar)
      } else if (item.type === 'date') {//将带有年月日的事件类型值转换
        datavar = utils.filterTime(datavar, 'date')
      } else if (item.type === 'table' || item.type === 'image' || item.type === 'apicom' || item.type === 'upimg' || item.type === 'upfile') {
        datavar = '点击查看明细'
      } else {
        // 处理数组类型的值
        if (Array.isArray(datavar)) {
          // 如果当前值本身就是数组，直接用逗号分割
          datavar = datavar.join(',')
        } else if (typeof datavar === 'string') {
          // 如果是字符串，尝试解析为数组
          try {
            const parsedArray = JSON.parse(datavar)
            if (Array.isArray(parsedArray)) {
              datavar = parsedArray.join(',')
            } else {
              datavar = datavar.toString()
            }
          } catch (e) {
            datavar = datavar.toString()
          }
        }
      }
      
      if ((item.labletype === 'Array') && item.type != 'table' && item.type != 'apicom') {
        try {
          const parsedArray = JSON.parse(datavar)
          if (Array.isArray(parsedArray)) {
            datavar = parsedArray.join(',')
          } else {
            datavar = parsedArray.toString()
          }
        } catch (e) {
          datavar = datavar.toString()
        }
      }

    }
    return datavar
  },
  //格式化组件元素值
  FormatFormLable(item) {//item为单个元素组件，如果获取到组件元素列表需要循环获取item

    //1.获取到数据后第一时间将默认数据为Array集合类型的转换
    if (item.labletype == "Array") {
      item.defaultlable = JSON.parse(item.defaultlable ? item.defaultlable : '[]')
    }
    //2.将表格数据的组件集转换
    item.tableformlist = JSON.parse(item.tableformlist ? item.tableformlist : '[]')
    // 表格 / apicom：补全子列 formtype、tablekey（公式引擎与 field-change 均依赖）
    if (item.type === 'table' || item.type === 'apicom') {
      if (!item.formtype) item.formtype = 'form'
      item.tableformlist.forEach((sub) => {
        if (!sub.tablekey) sub.tablekey = item.model
        if (!sub.formtype) sub.formtype = 'table'
      })
    } else if (!item.formtype) {
      item.formtype = 'form'
    }
    //2.1.将tabs页签列表转换（从otherConfig中读取）
    if (item.type === 'tabs') {
      // 先解析 otherConfig（如果是字符串）
      let tabsConfig = {}
      if (item.otherConfig) {
        if (typeof item.otherConfig === 'string') {
          try {
            tabsConfig = JSON.parse(item.otherConfig)
          } catch(e) {
            tabsConfig = {}
          }
        } else if (typeof item.otherConfig === 'object') {
          tabsConfig = item.otherConfig
        }
      }
      
      // 从 otherConfig 中读取页签配置
      if (tabsConfig.tabslist) {
        item.tabslist = typeof tabsConfig.tabslist === 'string' 
          ? JSON.parse(tabsConfig.tabslist || '[]')
          : (Array.isArray(tabsConfig.tabslist) ? tabsConfig.tabslist : [])
      } else {
        item.tabslist = []
      }
      
      // 从 otherConfig 中读取 activeTab，如果未设置则使用第一个页签
      if (tabsConfig.activeTab) {
        item.activeTab = tabsConfig.activeTab
      } else if (item.tabslist && item.tabslist.length > 0) {
        item.activeTab = item.tabslist[0].model
      }
      
      // 从 otherConfig 中读取折叠状态
      if (tabsConfig.tabsContentCollapsed !== undefined) {
        item.tabsContentCollapsed = tabsConfig.tabsContentCollapsed
      }
    }
    //3.将关联字段数据表格回显内容转换
    item.roottablelabel = JSON.parse(item.roottablelabel && item.roottablelabel != 'False' ? item.roottablelabel : '[]')
    //3.将提取内容回显内容转换
    item.optstablelabel = JSON.parse(item.optstablelabel && item.optstablelabel != 'False' ? item.optstablelabel : '[]')
    //3.将提取内容回显内容转换
    item.apipair = JSON.parse(item.apipair && item.apipair != 'False' ? item.apipair : '[]')
    try{
      //4.将条件过滤设置转换
      item.rootFilter = JSON.parse(item.rootFilter && item.rootFilter != 'False' ? item.rootFilter : '{"syslabels":[],"labelitems":[]}')
    }catch(e){ 
      item.rootFilter = {"syslabels":[],"labelitems":[]}
    }
    try{
      //5.将其他配置项转换
      // 判断是否为表格组件
      const isTableComponent = item.type === 'table' || item.type === 'apicom'
      
      if (!item.otherConfig || item.otherConfig === 'False') {
        // 表格组件：默认开启所有按钮（兼容旧数据）
        // 非表格组件：默认关闭 enableAdd
        if (isTableComponent) {
          item.otherConfig = {"tableEnableAdd":true,"tableEnableAddOnEdit":true,"tableEnableCopy":true,"tableEnableDelete":true,"tableEnableDeleteOnEdit":true,"viewPermissionPortal":"","viewPermissionFallback":[],"viewPermissionFallbackOr":[]}
        } else {
        item.otherConfig = {"enableAdd":false,"enableMultiline":false,"enableClueComponent":false,"viewPermissionPortal":"","viewPermissionFallback":[],"viewPermissionFallbackOr":[]}
        }
      } else if (typeof item.otherConfig === 'string') {
        item.otherConfig = JSON.parse(item.otherConfig)
        // 表格组件：使用新的属性名 tableEnableAdd、tableEnableCopy、tableEnableDelete
        if (isTableComponent) {
          if (item.otherConfig.tableEnableAdd === undefined) item.otherConfig.tableEnableAdd = true
          if (item.otherConfig.tableEnableAddOnEdit === undefined) item.otherConfig.tableEnableAddOnEdit = item.otherConfig.tableEnableAdd
          if (item.otherConfig.tableEnableCopy === undefined) item.otherConfig.tableEnableCopy = true
          if (item.otherConfig.tableEnableDelete === undefined) item.otherConfig.tableEnableDelete = true
          if (item.otherConfig.tableEnableDeleteOnEdit === undefined) item.otherConfig.tableEnableDeleteOnEdit = item.otherConfig.tableEnableDelete
        } else {
          // 非表格组件：enableAdd 默认为 false
        if (item.otherConfig.enableAdd === undefined) item.otherConfig.enableAdd = false
        if (item.otherConfig.enableMultiline === undefined) item.otherConfig.enableMultiline = false
        if (item.otherConfig.enableClueComponent === undefined) item.otherConfig.enableClueComponent = false
        }
        if (item.otherConfig.viewPermissionPortal === undefined) item.otherConfig.viewPermissionPortal = ''
        if (!Array.isArray(item.otherConfig.viewPermissionFallback)) item.otherConfig.viewPermissionFallback = []
        if (!Array.isArray(item.otherConfig.viewPermissionFallbackOr)) item.otherConfig.viewPermissionFallbackOr = []
      } else if (typeof item.otherConfig === 'object') {
        // 表格组件：使用新的属性名 tableEnableAdd、tableEnableCopy、tableEnableDelete
        if (isTableComponent) {
          if (item.otherConfig.tableEnableAdd === undefined) item.otherConfig.tableEnableAdd = true
          if (item.otherConfig.tableEnableAddOnEdit === undefined) item.otherConfig.tableEnableAddOnEdit = item.otherConfig.tableEnableAdd
          if (item.otherConfig.tableEnableCopy === undefined) item.otherConfig.tableEnableCopy = true
          if (item.otherConfig.tableEnableDelete === undefined) item.otherConfig.tableEnableDelete = true
          if (item.otherConfig.tableEnableDeleteOnEdit === undefined) item.otherConfig.tableEnableDeleteOnEdit = item.otherConfig.tableEnableDelete
        } else {
          // 非表格组件：enableAdd 默认为 false
        if (item.otherConfig.enableAdd === undefined) item.otherConfig.enableAdd = false
        if (item.otherConfig.enableMultiline === undefined) item.otherConfig.enableMultiline = false
        if (item.otherConfig.enableClueComponent === undefined) item.otherConfig.enableClueComponent = false
        }
        if (item.otherConfig.viewPermissionPortal === undefined) item.otherConfig.viewPermissionPortal = ''
        if (!Array.isArray(item.otherConfig.viewPermissionFallback)) item.otherConfig.viewPermissionFallback = []
        if (!Array.isArray(item.otherConfig.viewPermissionFallbackOr)) item.otherConfig.viewPermissionFallbackOr = []
      }
    }catch(e){ 
      // 表格组件：默认开启所有按钮（兼容旧数据）
      // 非表格组件：默认关闭 enableAdd
      const isTableComponent = item.type === 'table' || item.type === 'apicom'
      if (isTableComponent) {
        item.otherConfig = {"tableEnableAdd":true,"tableEnableAddOnEdit":true,"tableEnableCopy":true,"tableEnableDelete":true,"tableEnableDeleteOnEdit":true,"viewPermissionPortal":"","viewPermissionFallback":[],"viewPermissionFallbackOr":[]}
      } else {
      item.otherConfig = {"enableAdd":false,"enableMultiline":false,"enableClueComponent":false,"viewPermissionPortal":"","viewPermissionFallback":[],"viewPermissionFallbackOr":[]}
      }
    }
    
    //将控件启用状态转换
    item.disabled = (item.disabled === 'True' || item.disabled === 'true') ? true : false
    //将判断值唯一状态转换
    item.isonly = (item.isonly === 'True' || item.isonly === 'true') ? true : false
    //将判断值唯一状态转换
    item.ismultiple = (item.ismultiple === 'True' || item.ismultiple === 'true') ? true : false
    //将必填选项状态转换，并添加验证信息
    item.required = (item.required === 'True' || item.required === 'true') ? true : false
    //将编辑时禁用状态栏转换
    item.editdisabled = (item.editdisabled === 'True' || item.editdisabled === 'true') ? true : false
    apiworkClue.normalizeFormItemClueConfig(item)
    return item
  },
  //点选关联数据时格式化回显内容,workitem:表单的组件，workdata，提取源数据，itemdata：当前组件的数据，用来拼接等操作
  FormatWorkVal(workitem, workdata, itemdata = null) {//workitem:为目标元素，workdata：为选择的关联数据组

    let retval = ""
    if (workitem.type != "table" && workitem.type != "apicom") {
      //回显数据已设置，且关联字段为数据表格时进入
      if (workitem.roottablelabel && (workitem.rootlabel.includes('table') || workitem.rootlabel.includes('apicom'))) {
        //将要回显的opts下拉内容
        let retopts = ""
        //将数据表格元素的内容进行转换成数组
        let worktablearry = JSON.parse(workdata[workitem.rootlabel])
        //将数据表格中的数据进行循环每一行
        worktablearry.forEach(tableitem => {
          //循环当前表单元素要回显的数据表格内容
          workitem.roottablelabel.forEach(item => {
            //赋值拼接下拉选项的下拉内容
            retopts += tableitem[item].replaceAll(";", "；") + '，';//替换掉英文的分号，避免转义为多项下来内容
          })
          if (retval == "")//如果要返回的值是空的证明是第一次进入到循环中
          {
            retval = retopts.substring(0, retopts.length - 1)//赋值返回要回显的内容
          }
          if (retopts != "") {
            //截取掉最后一位的逗号，添加英文;来设置多项下拉内容
            retopts = retopts.substring(0, retopts.length - 1) + ";";
          }
        })
        //当目标元素对象类型是下拉选择，单项选择，单选按钮，多项选择时
        if (workitem.type === "select" || workitem.type === "radio" || workitem.type === "radiobutton" || workitem.type === "checkbox") {
          //当下拉选项内容不为空的时候就赋值给元素组件下拉内容
          workitem.selectopts = retopts//设置下拉框选项内容
          return retval
        } else {//如果当前组件不是下拉选择，是其他类型时，直接将拼接的下拉内容也就是数据表格所有行数据拼接返回回显
          return retopts

        }


      } else {
        retval = workdata[workitem.rootlabel]
      }
    } else {
      let apitxtjson = []//声明新的arry来处理接收数据

      //循环获取的表内容
      JSON.parse(workdata[workitem.rootlabel]).forEach(dataitem => {
        //声明数据表格行数据对象，插入标识key，标识唯一方便操作数据
        let tb_date_item = {
          key: `${Date.now()}_${Math.floor(Math.random() * 1000000)}_${Math.random().toString(36).slice(2, 8)}`
        };
        workitem.apipair.forEach(pairitem => {//根据回显设置将内容赋值给数据行
          tb_date_item[pairitem.model] = dataitem[pairitem.apimodel]//这里不能用   this.$set 直接给对象赋值创建
        })
        //将行加入到数据中
        apitxtjson.push(tb_date_item)
      })
      if (workitem.apisetstyle === "拼接显示") {//如果回显设置的是拼接，就将数据拼接给表格显示
        apitxtjson.forEach(i => {
          itemdata.push(i)
        })
        retval = itemdata

      } else {
        //如果回显设置的其他就直接显示出来
        retval = JSON.parse(JSON.stringify(apitxtjson))
      }
    }
    return retval
  },
  //点选关联数据时格式化回显内容，pairitem：当前匹配数组集。formlabelitem：当前表单的元素组件，locform：当前表单的数据，workdata：接口数据的值,apismtxtlbd，扫描的检索值
  FormatApiWorkVal(pairitem, formlabelitem, locform, workdata,apismtxtlb) {
    // 防护：如果 workdata 为 undefined 或 null，直接返回
    if (!workdata) {
      // console.warn('FormatApiWorkVal: workdata 为空，跳过字段赋值')
      return
    }

    if (formlabelitem.type === 'table' || formlabelitem.type === 'apicom') {
      let apitxtjson = []//声明新的arry来处理接收数据
      if(workdata[pairitem.apimodel]){//如果要提取的字段表格数据不是空的时候进入
        let workdataarry = []
        let sourceValue = workdata[pairitem.apimodel]
        
        // 判断源数据是否为表格数据（数组或JSON字符串）
        if (Array.isArray(sourceValue)) {
          workdataarry = sourceValue
        } else if (typeof sourceValue === 'string') {
          try {
            // 尝试解析为JSON数组
            let parsed = JSON.parse(sourceValue)
            if (Array.isArray(parsed)) {
              workdataarry = parsed
            } else {
              // 如果不是数组，将单个值转换为数组（非表格字段转表格）
              workdataarry = [parsed]
            }
          } catch (e) {
            // 解析失败，将单个值转换为数组（非表格字段转表格）
            workdataarry = [sourceValue]
          }
        } else {
          // 非数组、非字符串类型，将单个值转换为数组（非表格字段转表格）
          workdataarry = [sourceValue]
        }
        
        workdataarry.forEach(workdataitem => {//循环表格数据进行提前表格数据操作
        //声明数据表格行数据对象，插入标识key，标识唯一方便操作数据
        let tb_date_item = {
          key: `${Date.now()}_${Math.floor(Math.random() * 1000000)}_${Math.random().toString(36).slice(2, 8)}`
        };
          tb_date_item.apicomsmmactxt=apismtxtlb//将扫描的值放入表格数据行中
        // 检查是否有设置表格回显关联（pairlb）
        if(pairitem["pairlb"] && Array.isArray(pairitem["pairlb"]) && pairitem["pairlb"].length > 0){
          // 如果有设置回显关联，根据回显设置将内容赋值给数据行
          pairitem["pairlb"].forEach(subpitem => {
            // 如果workdataitem是基本类型（非对象），说明是从非表格字段转换来的
            // 此时需要从整个workdata对象中提取字段值
            let fieldValue = null
            if (typeof workdataitem === 'object' && workdataitem !== null && !Array.isArray(workdataitem)) {
              // 如果是对象，从对象中提取字段值
              fieldValue = workdataitem[subpitem.apimodel]
            } else {
              // 如果是基本类型，说明是从非表格字段转换来的，从整个workdata中提取
              // 如果apimodel匹配当前字段，使用workdataitem的值；否则从workdata中提取
              if (pairitem.apimodel === subpitem.apimodel) {
                fieldValue = workdataitem
              } else {
                fieldValue = workdata[subpitem.apimodel]
              }
            }
            
            // 从目标表格的字段配置中查找对应字段的配置信息
            let targetFieldConfig = null
            if (formlabelitem.tableformlist && Array.isArray(formlabelitem.tableformlist)) {
              targetFieldConfig = formlabelitem.tableformlist.find(field => field.model === subpitem.model)
            }
            
            // 根据字段类型处理值
            if (targetFieldConfig) {
              // checkbox 类型：值必须是数组，且数组中的值是 label（选项的显示文本）
              if (targetFieldConfig.type === 'checkbox') {
                if (Array.isArray(fieldValue)) {
                  tb_date_item[subpitem.model] = fieldValue
                } else if (fieldValue != null && fieldValue !== '') {
                  // 尝试解析为数组
                  try {
                    const parsed = JSON.parse(fieldValue)
                    tb_date_item[subpitem.model] = Array.isArray(parsed) ? parsed : [parsed]
                  } catch (e) {
                    // 解析失败，如果是字符串，按逗号分割
                    if (typeof fieldValue === 'string') {
                      tb_date_item[subpitem.model] = fieldValue.split(',').map(v => v.trim()).filter(v => v)
                    } else {
                      tb_date_item[subpitem.model] = [fieldValue]
                    }
                  }
                } else {
                  tb_date_item[subpitem.model] = []
                }
              } else {
                // 判断是否为数组类型字段（多选下拉框或数组类型）
                const isArrayField = targetFieldConfig.labletype === "Array" || 
                                     (targetFieldConfig.type === "select" && targetFieldConfig.ismultiple)
                
                if (isArrayField) {
                  // 数组类型字段：确保值是数组
                  if (Array.isArray(fieldValue)) {
                    tb_date_item[subpitem.model] = fieldValue
                  } else if (fieldValue != null && fieldValue !== '') {
                    // 尝试解析为数组
                    try {
                      const parsed = JSON.parse(fieldValue)
                      tb_date_item[subpitem.model] = Array.isArray(parsed) ? parsed : [parsed]
                    } catch (e) {
                      // 解析失败，如果是字符串，按逗号分割
                      if (typeof fieldValue === 'string') {
                        tb_date_item[subpitem.model] = fieldValue.split(',').map(v => v.trim()).filter(v => v)
                      } else {
                        tb_date_item[subpitem.model] = [fieldValue]
                      }
                    }
                  } else {
                    tb_date_item[subpitem.model] = []
                  }
                } else {
                  // 非数组类型字段：确保值是字符串或基本类型
                  if (Array.isArray(fieldValue)) {
                    // 如果是数组，转换为字符串（用逗号连接）
                    tb_date_item[subpitem.model] = fieldValue.join(',')
                  } else if (fieldValue != null && fieldValue !== undefined) {
                    // 数字类型字段：按照 floatnum 设置保留小数位
                    if (targetFieldConfig.type === 'num') {
                      const floatnum = (targetFieldConfig.floatnum !== undefined && targetFieldConfig.floatnum !== null) ? targetFieldConfig.floatnum : 0
                      tb_date_item[subpitem.model] = utils.changeflaot(fieldValue, floatnum)
                    } else {
                      // 其他类型：确保是字符串类型（对于下拉框，需要字符串值才能正确显示）
                      tb_date_item[subpitem.model] = String(fieldValue)
                    }
                  } else {
                    tb_date_item[subpitem.model] = ''
                  }
                }
              }
            } else {
              // 如果没有找到字段配置，直接赋值（兼容旧逻辑）
              tb_date_item[subpitem.model] = fieldValue
            }
          })
        } else {
          // 如果没有设置回显关联，根据workdataitem的类型处理
          if (typeof workdataitem === 'object' && workdataitem !== null && !Array.isArray(workdataitem)) {
            // 如果是对象，直接将整个workdataitem作为行数据（兼容旧逻辑）
            Object.keys(workdataitem).forEach(key => {
              tb_date_item[key] = workdataitem[key]
            })
          } else {
            // 如果是基本类型（非表格字段转换来的），将整个workdata作为行数据
            // 同时将原始值也放入行数据中，使用apimodel作为key
            if (pairitem.apimodel) {
              tb_date_item[pairitem.apimodel] = workdataitem
            }
            // 将workdata中的其他字段也添加到行数据中
            Object.keys(workdata).forEach(key => {
              if (key !== pairitem.apimodel) {
                tb_date_item[key] = workdata[key]
              }
            })
          }
        }
          //将行加入到数据中
          apitxtjson.push(tb_date_item)
        })

      }
      // 确保目标字段已初始化为数组
      if (!Array.isArray(locform[pairitem.model])) {
        locform[pairitem.model] = []
      }
      if(pairitem.apisetstyle === "拼接显示"){
        locform[pairitem.model].push(...apitxtjson)
      }else{
      locform[pairitem.model]= apitxtjson//通过方法转换，根据不同的组件类型获得不同的返回值内容
      }
    } else {
      // console.log('ft', pairitem) 
      // console.log('当前',formlabelitem);
      
      // 优先处理 upfile/upimg/image 类型，保证 fileList 为数组
      if (formlabelitem.type === 'upfile' || formlabelitem.type === 'upimg' || formlabelitem.type === 'image') {
        let val = workdata[pairitem["apimodel"]];
        if (typeof val === "string") {
          try {
            locform[pairitem.model] = JSON.parse(val);
          } catch (e) {
            locform[pairitem.model] = [];
          }
        } else if (Array.isArray(val)) {
          locform[pairitem.model] = val;
        } else {
          locform[pairitem.model] = [];
        }
        return;
      }
      
      // 数字类型字段处理：按照 floatnum 设置保留小数位（优先处理）
      if (formlabelitem.type === 'num') {
        let val = workdata[pairitem["apimodel"]];
        if (val != null && val !== '' && val !== undefined) {
          const floatnum = (formlabelitem.floatnum !== undefined && formlabelitem.floatnum !== null) ? formlabelitem.floatnum : 0
          locform[pairitem.model] = utils.changeflaot(val, floatnum)
        } else {
          locform[pairitem.model] = ''
        }
        return;
      }
      
      if(formlabelitem.labletype==="String") {
        let val = workdata[pairitem["apimodel"]];  
        if (Array.isArray(val)) {
          locform[pairitem.model] = val.join(",");
        } else if (typeof val === "string") {
          // 尝试解析为数组
          try {
            let arr = JSON.parse(val);
            if (Array.isArray(arr)) {
              locform[pairitem.model] = arr.join(",");
            } else {
              locform[pairitem.model] = val;
            }
          } catch (e) {
            locform[pairitem.model] = val;
          }
        } else if (val != null) {
          locform[pairitem.model] = val.toString();
        } else {
          locform[pairitem.model] = '';
        }
      }else{
        // 使用统一的数据转换方法
        let val = workdata[pairitem["apimodel"]];
        locform[pairitem.model] = this.convertFieldValue(val, formlabelitem);
   }
    }
  },
  
  // 统一判断数组类型字段的方法
  isArrayField(item) {
    return item.labletype === "Array" || 
           ((item.type === "select" || item.type === "equser" || item.type === "eqrole") && item.ismultiple) ||
           item.type === "checkbox";
  },
  
  // 统一数组字段值转换方法
  parseArrayFieldValue(value) {
    if (Array.isArray(value)) {
      return value;
    }
    if (value) { 
      try {
        return JSON.parse(value);
      } catch (e) { 
        // 如果JSON解析失败，尝试按逗号分割
        if (typeof value === 'string') {
          return value.split(',').map(item => item.trim());
        }
        return [];
      }
    } else {
      return [];
    }
  },
  
  // 统一数据转换方法
  convertFieldValue(value, formlabelitem) {
    if (!formlabelitem) {
      return value;
    }
    
    // 数组类型字段处理
    if (this.isArrayField(formlabelitem)) {
      return this.parseArrayFieldValue(value);
    }
    
    // 数字类型字段处理：按照 floatnum 设置保留小数位
    if (formlabelitem.type === 'num') {
      if (value != null && value !== '' && value !== undefined) {
        const floatnum = (formlabelitem.floatnum !== undefined && formlabelitem.floatnum !== null) ? formlabelitem.floatnum : 0
        return utils.changeflaot(value, floatnum)
      }
      return value
    }
    
    // String类型字段处理
    if (formlabelitem.labletype === "String") {
      if (Array.isArray(value)) {
        return value.join(",");
      } else if (typeof value === "string") {
        try {
          let arr = JSON.parse(value);
          if (Array.isArray(arr)) {
            return arr.join(",");
          } else {
            return value;
          }
        } catch (e) {
          return value;
        }
      } else if (value != null) {
        return value.toString();
      } else {
        return '';
      }
    }
    
    // 文件上传类型处理
    if (formlabelitem.type === 'upfile' || formlabelitem.type === 'upimg') {
      if (typeof value === "string") {
        try {
          return JSON.parse(value);
        } catch (e) {
          return [];
        }
      } else if (Array.isArray(value)) {
        return value;
      } else {
        return [];
      }
    }
    
    // 其他类型直接返回
    return value;
  }
}
